<template>
  <div class="entrustOrderDetail">
    <van-form label-width="120px">
      <div class="title">{{ $t.meta.basicTitle }}</div>
      <van-field
        v-model="content.OrderNumber"
        :label="$t.salesManagement.erNumber"
        label-class="number-label"
        disabled
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="onCopy(content.OrderNumber)"
            native-type="button"
            >{{ $t.meta.copy }}</van-button
          >
        </template>
      </van-field>

      <van-field
        v-model="content.DeliveryCityName"
        :label="$t.salesManagement.deliveryCity"
        disabled
      />
      <van-field
        v-model="content.DestinationCityName"
        :label="$t.salesManagement.destinationCity"
        disabled
      />
      <van-field
        v-model="content.BusinessTypeStr"
        :label="$t.salesManagement.transportType"
        disabled
      />
      <van-field v-model="weightStr" :label="$t.salesManagement.weight" disabled />
      <van-field
        v-model="content.CreateTime"
        :label="$t.salesManagement.entrustDay"
        disabled
      />

      <van-field
        v-model="form.GoodsName"
        :label="$t.salesManagement.goodsNameEn"
        label-class="number-label"
        :placeholder="$t.meta.input"
      >
        <template #button>
          <van-button
            size="small"
            type="info"
            @click="editGoodsName"
            native-type="button"
            >{{ $t.meta.save }}</van-button
          >
        </template>
      </van-field>

      <div class="title">{{ $t.salesManagement.billInformation }}</div>

      <span v-if="form.Shipper">
        <van-field :label="$t.meta.operate" label-class="number-label" readonly>
          <template #button>
            <van-button
              size="small"
              type="primary"
              native-type="button"
              @click="onShowEmit('showEntrustOrderCompany', 'Shipper')"
              style="margin-right: 20px"
              >{{ $t.meta.search }}</van-button
            >
            <van-button
              size="small"
              type="info"
              @click="updateEntrustOrderContactRecord(1)"
              >{{ $t.meta.save }}</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="form.Shipper.CompanyName"
          :label="$t.salesManagement.shipper"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.Shipper.Address"
          :label="$t.salesManagement.shipperAddress"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.Shipper.ContactPhone"
          :label="$t.salesManagement.shipperPhone"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.Shipper.Email"
          :label="$t.salesManagement.shipperEmail"
          :placeholder="$t.meta.input"
        />
      </span>

      <span v-if="form.Consignee">
        <van-field :label="$t.meta.operate" label-class="number-label" readonly>
          <template #button>
            <van-button
              size="small"
              type="primary"
              native-type="button"
              @click="onShowEmit('showEntrustOrderCompany', 'Consignee')"
              style="margin-right: 20px"
              >{{ $t.meta.search }}</van-button
            >

            <van-button
              size="small"
              type="info"
              @click="updateEntrustOrderContactRecord(2)"
              >{{ $t.meta.save }}</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="form.Consignee.CompanyName"
          :label="$t.salesManagement.consignee"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.Consignee.Address"
          :label="$t.salesManagement.consigneeAddress"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.Consignee.ContactPhone"
          :label="$t.salesManagement.consigneePhone"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.Consignee.Email"
          :label="$t.salesManagement.consigneeEmail"
          :placeholder="$t.meta.input"
        />
      </span>

      <span v-if="form.Notify">
        <van-field :label="$t.meta.operate" label-class="number-label" readonly>
          <template #button>
            <van-button
              size="small"
              type="primary"
              native-type="button"
              @click="onShowEmit('showEntrustOrderCompany', 'Notify')"
              style="margin-right: 20px"
              >{{ $t.meta.search }}</van-button
            >

            <van-button
              size="small"
              type="info"
              @click="updateEntrustOrderContactRecord(3)"
              >{{ $t.meta.save }}</van-button
            >
          </template>
        </van-field>
        <van-field
          v-model="form.Notify.CompanyName"
          :label="$t.salesManagement.notify"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.Notify.Address"
          :label="$t.salesManagement.notifyAddress"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.Notify.ContactPhone"
          :label="$t.salesManagement.notifyPhone"
          :placeholder="$t.meta.input"
        />
        <van-field
          v-model="form.Notify.Email"
          :label="$t.salesManagement.notifyEmail"
          :placeholder="$t.meta.input"
        />
      </span>

      <div class="title">{{ $t.salesManagement.supplierList }}</div>

      <div class="multi-table" v-if="content.SupplierList">
        <van-field name="stepper" :label="$t.salesManagement.supplier" required>
          <template #input>
            <van-stepper
              :min="0"
              :value="content.SupplierCount"
              @plus="handleAdd(content.SupplierCount + 1)"
              :disable-input="true"
              :disable-minus="true"
            />
          </template>
        </van-field>
        <div v-for="(item, index) in content.SupplierList" :key="index">
          <div class="multi-table-header">
            <div class="multi-table-title">
              {{ $t.salesManagement.supplier }} {{ index + 1 }}
            </div>
          </div>
          <van-field
            v-model="item.WarehouseNumber"
            :label="$t.salesManagement.warehouseNumber"
            label-class="number-label"
            disabled
          >
            <template #button>
              <van-button
                size="small"
                type="info"
                @click="onCopy(item.WarehouseNumber)"
                native-type="button"
                v-if="item.WarehouseNumber"
                >{{ $t.meta.copy }}</van-button
              >
            </template>
          </van-field>
          <van-field
            v-model="item.Email"
            :label="$t.salesManagement.email"
            label-class="number-label"
            disabled
          >
            <template #button>
              <van-button
                size="small"
                type="info"
                @click="onCopy(item.Email)"
                native-type="button"
                v-if="item.Email"
                >{{ $t.meta.copy }}</van-button
              >
            </template>
          </van-field>
          <van-field
            v-model="item.InvoiceStateStr"
            :label="$t.salesManagement.invoice"
            disabled
          />
          <van-field
            v-model="item.PackingListStateStr"
            :label="$t.salesManagement.packingList"
            disabled
          />
          <van-field
            v-model="item.GoodsStateStr"
            :label="$t.salesManagement.goodState"
            disabled
          />
          <van-field
            :label="$t.salesManagement.emailShare"
            label-class="number-label"
            disabled
          >
            <template #button>
              <van-button size="small" type="info" @click="emailShow(item.EOSId)">{{
                $t.salesManagement.clickShare
              }}</van-button>
            </template>
          </van-field>
        </div>
      </div>
    </van-form>

    <van-dialog
      :title="$t.salesManagement.sendInvite"
      width="90%"
      v-model="emailVisible"
      @cancel="emailVisible = false"
      @confirm="entrustOrderInvitationEmail"
      :cancel-button-text="$t.meta.close"
      :confirm-button-text="$t.meta.confirm"
      :show-cancel-button="true"
      :show-confirm-button="true"
    >
      <slot name="default">
        <div class="entrustOrderDetail-alert">
          <van-form label-width="80px">
            <van-field
              v-model="inviter.email"
              :label="$t.salesManagement.email"
              :placeholder="$t.salesManagement.placeholderEmail"
              type="textarea"
              required
            />
          </van-form>
        </div>
      </slot>
    </van-dialog>

    <customer-fetch-list
      event="showEntrustOrderCompany"
      @onSelect="onSelectFetch"
    ></customer-fetch-list>
  </div>
</template>
<script>
import Vue from "vue";
import { Form, Field, Button, Stepper } from "vant";
import CustomerFetchList from "@components/customerFetchList/CustomerFetchList.vue";

Vue.use(Form).use(Field).use(Button).use(Stepper);

export default {
  name: "entrustOrderDetail",
  components: {
    CustomerFetchList,
  },
  data() {
    return {
      CustomerId: JSON.parse(localStorage.getItem("auth")).userInfo.CustomerId,
      orderId: "",
      content: {},
      weightStr: "",
      form: {
        GoodsName: "",
        Shipper: {
          CompanyName: "",
          Address: "",
          CRId: 0,
          ContactPhone: "",
          Email: "",
        },
        Consignee: {
          CompanyName: "",
          Address: "",
          CRId: 0,
          ContactPhone: "",
          Email: "",
        },
        Notify: {
          CompanyName: "",
          Address: "",
          CRId: 0,
          ContactPhone: "",
          Email: "",
        },
      },
      //邮箱分享
      emailVisible: false,
      inviter: {
        eosid: "",
        email: "",
      },
      formType: "",
    };
  },
  created() {
    const { OrderId } = this.$route.query;
    if (OrderId) {
      this.orderId = OrderId;
      this.getEntrustOrderInfo();
    }
  },
  methods: {
    onSelectFetch(e) {
      this.form[this.formType].CompanyName = e.text;
      this.form[this.formType].CRId = e.value;
      this.form[this.formType].Address = e.Address;
      this.form[this.formType].ContactPhone = e.ContactPhone;
      this.form[this.formType].Email = e.Email;
    },
    onShowEmit(emit, type) {
      this.formType = type;
      this.$bus.$emit(emit, true);
    },
    emailShow(id) {
      this.inviter.eosid = id;
      this.emailVisible = true;
    },
    entrustOrderInvitationEmail() {
      this.$commonMethod.showLoading();
      let param = {
        EOSId: this.inviter.eosid,
        Email: this.inviter.email,
      };
      this.$api.logisticsManagement
        .entrustOrderInvitationEmail(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.emailVisible = false;
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getEntrustOrderSupplierFileList() {
      return new Promise((resolve) => {
        this.$commonMethod.showLoading();
        var param = {
          EOSId: this.files.eosid,
        };
        this.$api.logisticsManagement
          .getEntrustOrderSupplierFileList(param)
          .then((res) => {
            this.files.list = res.data || [];
            this.files.length = res.data.length + 1 || 0;
            resolve(true);
            this.$commonMethod.hideLoading();
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
          });
      });
    },
    handleAdd(qty) {
      this.$commonMethod.showLoading();
      var param = {
        OrderId: this.orderId,
        OrderNumber: this.content.OrderNumber,
        Quantity: qty,
      };
      this.$api.logisticsManagement
        .addEntrustOrderSupplier(param)
        .then(() => {
          this.getEntrustOrderInfo();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    getEntrustOrderInfo() {
      return new Promise((resolve, reject) => {
        this.$commonMethod.showLoading();
        var param = {
          OrderId: this.orderId,
        };
        this.$api.myCustomer
          .getEntrustOrderInfo(param)
          .then((res) => {
            this.content = res.data;
            this.weightStr = this.content.Weight + " " + this.content.WeightUnitName;
            this.form.GoodsName = this.content.GoodsName;
            if (this.content.Shipper) {
              this.form.Shipper = {
                CompanyName: this.content.Shipper.CompanyName,
                Address: this.content.Shipper.Address,
                CRId: this.content.Shipper.CRId,
                ContactPhone: this.content.Shipper.ContactPhone,
                Email: this.content.Shipper.Email,
              };
            }
            if (this.content.Shipper) {
              this.form.Consignee = {
                CompanyName: this.content.Consignee.CompanyName,
                Address: this.content.Consignee.Address,
                CRId: this.content.Consignee.CRId,
                ContactPhone: this.content.Consignee.ContactPhone,
                Email: this.content.Consignee.Email,
              };
            }
            if (this.content.Notify) {
              this.form.Notify = {
                CompanyName: this.content.Notify.CompanyName,
                Address: this.content.Notify.Address,
                CRId: this.content.Notify.CRId,
                ContactPhone: this.content.Notify.ContactPhone,
                Email: this.content.Notify.Email,
              };
            }
            this.$commonMethod.fieldRefresh(".entrustOrderDetail");
            this.$commonMethod.hideLoading();
            resolve(true);
          })
          .catch((error) => {
            this.$commonMethod.hideLoading();
            this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
              msg: error.message,
            });
            reject();
          });
      });
    },
    updateEntrustOrderContactRecord(contactType) {
      var param = {
        ContactType: contactType,
        OrderId: this.orderId,
        CustomerId: this.CustomerId,
      };
      if (contactType == 1) {
        param.CompanyName = this.form.Shipper.CompanyName;
        param.Address = this.form.Shipper.Address;
        param.CRId = this.form.Shipper.CRId;
        param.ContactPhone = this.form.Shipper.ContactPhone;
        param.Email = this.form.Shipper.Email;
      }
      if (contactType == 2) {
        param.CompanyName = this.form.Consignee.CompanyName;
        param.Address = this.form.Consignee.Address;
        param.CRId = this.form.Consignee.CRId;
        param.ContactPhone = this.form.Consignee.ContactPhone;
        param.Email = this.form.Consignee.Email;
      }
      if (contactType == 3) {
        param.CompanyName = this.form.Notify.CompanyName;
        param.Address = this.form.Notify.Address;
        param.CRId = this.form.Notify.CRId;
        param.ContactPhone = this.form.Notify.ContactPhone;
        param.Email = this.form.Notify.Email;
      }
      this.$commonMethod.showLoading();
      this.$api.myCustomer
        .updateEntrustOrderContactRecord(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.getEntrustOrderInfo();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    editGoodsName() {
      this.$commonMethod.showLoading();
      var param = {
        OrderId: this.orderId,
        GoodsName: this.form.GoodsName,
      };
      this.$api.myCustomer
        .editGoodsName(param)
        .then((res) => {
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showNotify, {
            titleMsg: res.message,
            type: "success",
          });
          this.getEntrustOrderInfo();
          this.$commonMethod.hideLoading();
        })
        .catch((error) => {
          this.$commonMethod.hideLoading();
          this.$commonEnv.commonAction(this.$commonEnv.actionType.showDialog, {
            msg: error.message,
          });
        });
    },
    onCopy(text) {
      this.$commonEnv.commonAction(this.$commonEnv.actionType.clickCopy, {
        text: text,
        alertText: this.$t.meta.copySuccess,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.entrustOrderDetail {
  ::v-deep .number-label {
    line-height: 33px;
  }

  ::v-deep .van-field--disabled {
    .van-field__label,
    .van-field__control {
      color: #999 !important;
      -webkit-text-fill-color: #999 !important;
    }
  }

  .van-cell {
    border-bottom: 1px solid #ebedf0;

    .van-button {
      padding: 6px 8px;
      height: auto;

      ::v-deep .van-button__text {
        font-size: 12px !important;
      }
    }
  }

  .van-cell::after {
    border: none !important;
  }

  .multi-table {
    .multi-table-header {
      padding: 10px 15px;
      background: #1e90ff;

      .multi-table-title {
        font-size: 14px;
        font-family: monospace;
        color: #fff;
        width: 50%;
        display: inline-block;
        vertical-align: middle;
      }

      .multi-table-btn {
        width: 50%;
        display: inline-block;
        text-align: right;
        vertical-align: middle;

        .van-icon {
          font-size: 20px;
          font-weight: bold;
          color: #fff;
        }
      }
    }
  }

  .entrustOrderDetail-alert {
    overflow: scroll;
    height: 100vw;
    margin-top: 30px;
    margin-bottom: 30px;
    border-top: 1px solid #ebedf0;

    .van-cell {
      border-bottom: 1px solid #ebedf0;
    }

    .van-cell::after {
      border: none !important;
    }
  }
}
</style>
